import http from '@/api/index.js';
import baseUrl from '@/api/baseUrl.js';

let url = baseUrl.common;

export const queryByPage = params => { return http.post(url + `/ProjectDetails/querybypage`, params) };
